module.exports = __webpack_public_path__ + "img/vector.365ba9b0.svg";